// ─────────────────────────────────────────────────────────────
// "Local know-how": little-known, service-related facts for each
// service-area page. Every fact links to the source it came from
// (researched September 2026). Laws and programs change, so re-check
// sources before relying on a fact in a sales conversation.
// ─────────────────────────────────────────────────────────────

const S = {
  luke: { label: "A.R.S. § 28-8482", url: "https://www.azleg.gov/ars/28/08482.htm" },
  heat: { label: "KJZZ", url: "https://www.kjzz.org/kjzz-news/2025-01-01/2024-will-likely-be-confirmed-as-phoenixs-hottest-year-ever" },
  youngtownHomes: { label: "Sun City Independent", url: "https://yourvalley.net/sun-city-independent/stories/signs-of-the-past-youngtown-came-first,248542" },
  peoria: { label: "City of Peoria profile", url: "https://my.recruitmilitary.com:443/organizations/city-of-peoria" },
  beyondCode: { label: "Sierra Club Grand Canyon Chapter", url: "https://www.sierraclub.org/sites/default/files/sce/grand-canyon-chapter/energy/LT2%20Energy%20Brochure.pdf" },
  scottsdale: { label: "ICMA / City of Scottsdale", url: "https://icma.org/sites/default/files/20794_104577.pdf" },
  queenCreek: { label: "AZFamily", url: "https://www.azfamily.com/2025/05/15/queen-creek-is-arizonas-fastest-growing-town-see-where-other-valley-cities-rank/" },
};

// Shared facts, phrased for each place
const lukeNoise = (name) => ({
  service: "Roofing",
  text: `Parts of ${name} lie in the Luke Air Force Base vicinity, where state law has local building codes require at least an R-30 roof/ceiling assembly, R-18 walls and dual-pane windows (or an engineer's certification of a 45-decibel interior). Stricter rules apply inside the base's noise contours, and the roof assembly is the part that matters most on a re-roof.`,
  source: S.luke,
});
const valleyHeat = {
  service: "Roofing",
  text: "In 2024 the Phoenix area went a record 113 straight days at 100°F or hotter (the old record was 76), with 39 nights that never dropped below 90°F. Roof underlayment, shingles and foam coatings age on that clock, not the one printed on the warranty.",
  source: S.heat,
};

export const localFacts = {
  peoria: [
    { service: "Local", text: "Peoria has grown from one square mile around Old Town to more than 176 square miles across both Maricopa and Yavapai counties, and Lake Pleasant sits inside the city. Some northern Peoria addresses are in a different county than the rest of town.", source: S.peoria }
    ],
  glendale: [lukeNoise("Glendale")],
  surprise: [lukeNoise("Surprise")],
  "sun-city-west": [],
  "el-mirage": [lukeNoise("El Mirage") ],
  youngtown: [
    { service: "Roofing", text: "Youngtown, founded in 1954, was the nation's first retirement community. Its first homes were about 750 square feet and sold for under $8,000, so many original roofs and cooling systems have likely been replaced more than once.", source: S.youngtownHomes }
  ],
  goodyear: [
    lukeNoise("Goodyear")
  ],
  avondale: [
    lukeNoise("Avondale")
  ],
  "litchfield-park": [lukeNoise("Litchfield Park") ],
  tolleson: [valleyHeat],
  buckeye: [
    { service: "Energy Efficiency", text: "The Sierra Club's Arizona chapter lists Buckeye among the few Arizona municipalities with beyond-code energy standards, programs that go past the minimum efficiency requirements for new construction.", source: S.beyondCode }
  ],
  phoenix: [
    valleyHeat
  ],
  guadalupe: [valleyHeat],
  anthem: [],
  carefree: [],
  scottsdale: [
    { service: "Roofing", text: "Scottsdale launched Arizona's first green building program in 1998, focused on homes. In 2005 it became the first U.S. city to require all new occupied city buildings to reach LEED Gold.", source: S.scottsdale }
    ],
  "paradise-valley": [],
  "fountain-hills": [],
  tempe: [],
  mesa: [],
  chandler: [],
  gilbert: [],
  "queen-creek": [
    { service: "Roofing", text: "Census estimates named Queen Creek Arizona's fastest-growing town, adding about 6,286 residents (8.1%) between July 2023 and July 2024. A lot of that housing went up at once, which means a lot of roofs will reach the end of their first underlayment at once too.", source: S.queenCreek }
  ],
  "apache-junction": [
    { service: "Energy Efficiency", text: "The Sierra Club's Arizona chapter lists Apache Junction among the few Arizona municipalities with beyond-code energy standards for construction.", source: S.beyondCode }
    ],
};

export const areaFacts = (slug) => localFacts[slug] || [];
